import React from "react";
import { Redirect } from "react-router";
import { translate } from "react-i18next";

const LoginRedirect = ({ t, successMessage }) => (
  <Redirect
    to={{
      pathname: "/app/login",
      state: { formSuccessMessage: t(successMessage) },
    }}
  />
);

export default translate("translations")(LoginRedirect);



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/LoginRedirect.js